module.exports = __webpack_public_path__ + "img/bamboo-vein.eaaa0bb8.png";